import React, { useState } from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
import { ListView } from './ListView';
import { CalendarView } from './CalendarView';
import { GoalTracker } from './GoalTracker';
import { PlanCreationFlow } from './PlanCreationFlow';
interface PlanTrackingFlowProps {
  navigateTo: (screen: string) => void;
}
export const PlanTrackingFlow = ({
  navigateTo
}: PlanTrackingFlowProps) => {
  const [activeView, setActiveView] = useState('list');
  const [showPlanCreation, setShowPlanCreation] = useState(false);
  const mockWorkouts = [{
    id: 1,
    name: 'Upper Body Strength',
    date: '2023-05-01',
    completed: true
  }, {
    id: 2,
    name: 'Cardio Interval',
    date: '2023-05-03',
    completed: true
  }, {
    id: 3,
    name: 'Yoga & Mobility',
    date: '2023-05-05',
    completed: true
  }, {
    id: 4,
    name: 'Lower Body Focus',
    date: '2023-05-08',
    completed: false,
    skipped: true
  }, {
    id: 5,
    name: 'Core Strength',
    date: '2023-05-10',
    completed: true
  }, {
    id: 6,
    name: 'Full Body HIIT',
    date: '2023-05-12',
    completed: true
  }, {
    id: 7,
    name: 'Active Recovery',
    date: '2023-05-15',
    completed: false
  }, {
    id: 8,
    name: 'Upper Body Power',
    date: '2023-05-17',
    completed: false
  }, {
    id: 9,
    name: 'Cardio Endurance',
    date: '2023-05-19',
    completed: false
  }, {
    id: 10,
    name: 'Lower Body Strength',
    date: '2023-05-22',
    completed: false
  }];
  if (showPlanCreation) {
    return <PlanCreationFlow onBack={() => setShowPlanCreation(false)} data-id="element-992" />;
  }
  return <div className="flex flex-col h-full min-h-screen bg-white pb-16" data-id="element-993">
      <div className="p-6 border-b border-gray-100" data-id="element-994">
        <div className="flex justify-between items-center mb-4" data-id="element-995">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-996">Your Plan</h1>
          <div className="w-6" data-id="element-997"></div> {/* Empty div for flex alignment */}
        </div>
        <div className="flex rounded-lg overflow-hidden border border-gray-200" data-id="element-998">
          <button onClick={() => setActiveView('list')} className={`flex-1 py-2 text-center ${activeView === 'list' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700'}`} data-id="element-999">
            List
          </button>
          <button onClick={() => setActiveView('calendar')} className={`flex-1 py-2 text-center ${activeView === 'calendar' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700'}`} data-id="element-1000">
            Calendar
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-1001">
        {activeView === 'list' ? <ListView workouts={mockWorkouts} data-id="element-1002" /> : <CalendarView workouts={mockWorkouts} navigateTo={navigateTo} data-id="element-1003" />}
      </div>
      <div className="p-4 border-t border-gray-100 mb-16" data-id="element-1004">
        <div className="mb-4" data-id="element-1005">
          <Button onClick={() => setShowPlanCreation(true)} variant="primary" fullWidth data-id="element-1006">
            Create New Plan
          </Button>
        </div>
        <GoalTracker completed={5} total={246} data-id="element-1007" />
      </div>
    </div>;
};